import { motion } from "framer-motion";
import { Link, useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const HERO_IMAGE =
  "https://customer-assets-m6fa6gv7.emergentagent.net/job_renewable-ag-infra/artifacts/pir5ie7u_7776476f-e7ae-4061-92c5-730324a35a59.png";

export const AboutHero = () => {
  const navigate = useNavigate();

  return (
    <section
      data-testid="about-hero-section"
      className="bg-baseLight px-6 pt-[130px] pb-[30px] sm:pt-[150px] sm:pb-[40px] lg:px-12 lg:pt-[190px] lg:pb-[70px]"
    >
      <div className="lg:mx-auto lg:max-w-[1280px]">
        <div className="grid grid-cols-1 items-center gap-12 lg:grid-cols-12 lg:gap-16">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="lg:col-span-7"
          >
            <span data-testid="about-hero-eyebrow" className="text-sm font-medium text-teal">
              COMPANY
            </span>
            <h1
              data-testid="about-hero-headline"
              className="mt-3 font-heading text-[34px] font-semibold leading-[1.15] text-ink sm:text-[46px] lg:text-[55px]"
            >
              Engineering energy systems around real operations
            </h1>
            <p
              data-testid="about-hero-text"
              className="mt-[32px] lg:mt-6 max-w-xl text-[15px] leading-relaxed text-inkSoft"
            >
              Off-Grid Hydrogen is a British Columbia-focused systems-integration business
              developing hybrid renewable-energy and long-duration storage solutions for
              agricultural and rural operations.
            </p>
            <div className="mt-8 flex flex-wrap items-center gap-x-7 gap-y-4">
              <button
                type="button"
                data-testid="about-hero-cta-primary"
                onClick={() => navigate("/#contact")}
                className="inline-flex h-11 items-center bg-teal text-white text-sm font-medium rounded-full px-6 hover:bg-tealHover transition-all duration-300 hover:-translate-y-0.5"
              >
                Request an Energy Assessment
              </button>
              <Link
                to="/technology"
                data-testid="about-hero-cta-secondary"
                className="group inline-flex items-center gap-1.5 text-sm text-inkSoft hover:text-teal transition-colors duration-300"
              >
                <span className="underline decoration-borderSubtle group-hover:decoration-teal/60 transition-colors duration-300">
                  Explore Our Technology
                </span>
                <ArrowRight size={13} className="transition-transform duration-300 group-hover:translate-x-0.5" />
              </Link>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, scale: 0.97 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.7, delay: 0.1 }}
            className="lg:col-span-5"
          >
            <div
              data-testid="about-hero-visual"
              className="h-[280px] overflow-hidden rounded-3xl sm:h-[340px] lg:h-[374px]"
            >
              <img
                src={HERO_IMAGE}
                alt="Project professional at a rural energy site in British Columbia"
                className="h-full w-full object-cover object-center"
              />
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
